<div>
  @if (!toggle().doHide?.(row())) {
    <mat-slide-toggle
      [disabled]="toggle().isDisabled?.(row())"
      [checked]="value()"
      (change)="toggle().onToggle(row(), $event.checked)"
      (click)="preventBubble($event)"
      [matTooltip]="toggle().hoverText?.(row())"
    ></mat-slide-toggle>
  }
</div>
